import React, { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'

// Import Components
import { Plus } from '../svgs/Plus'
import { useTheme } from 'emotion-theming'
import { Link } from '@jelly/ui'

const Plate = styled.div`
	align-items: center;
	background: ${({ theme }) => theme.colors.white};
	box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.08);
	cursor: pointer;
	display: flex;
	height: 35px;
	justify-content: space-evenly;
	margin-left: auto;
	right: 0;
	transition: all 0.2s ease;
	width: 42px;
`
const Meatball = styled.div`
	background: ${({ theme }) => theme.bestPicks.meatballColor};
	border-radius: 50%;
	display: inline-block;
	height: 6px;
	width: 6px;
`

// Styled components via Emotion
const MenuWrapper = styled.div`
	display: block;
	margin-left: auto;
	position: fixed;
	z-index: ${({ isMenuVisible }) => (isMenuVisible ? '9999' : '2')};
	right: 0;
	${({ isMenuVisible }) => isMenuVisible && `width: 100%;`};

	&:hover {
		${Plate} {
			background: ${({ theme }) => theme.bestPicks.meatballColor};
		}
		${Meatball} {
			background: ${({ theme }) => theme.colors.white};
		}
	}

	${({ theme }) => theme.MQ.M} {
		top: 10vh;
	}

	${({ theme }) => theme.MQ.L} {
		display: none;
	}
`

const MeatballWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 22px;
`
const Overlay = styled.div`
	background: #000000;
	display: ${({ isOverlayVisible }) => (isOverlayVisible ? `block` : `none`)};
	position: absolute;
	height: 100vh;
	opacity: 0.5;
	top: 0;
	z-index: 9998;
	width: 100%;
`
const Menu = styled.div`
	background: ${({ theme }) => theme.colors.white};
	height: auto;
	margin-left: auto;
	padding: 22px;
	position: absolute;
	right: 0;
	top: 0;
	width: 90%;
`
const CloseButton = styled.div`
	cursor: pointer;
	display: block;
	margin-left: auto;
	right: 0;
	padding: 0 15px;
	position: absolute;

	svg {
		transform: rotate(45deg);
	}
`
const ElementLink = styled(Link)`
	color: ${({ theme }) => theme.links.darkGrey};
	cursor: pointer;
	display: block;
	font-size: 18px;
	margin: 1.5rem 0;
	width: fit-content;
`
MeatballMenu.propTypes = {
	elements: array.isRequired,
}

/**
 * Meatball menu, aka three dots horizontally aligned to indicate a hidden menu of links
 * @param {Array} elements :: a list of objects containing elements for links
 */
export function MeatballMenu({ elements }) {
	const [showMenu, setShowMenu] = useState(false)
	const overlayRef = useRef()
	const {
		bestPicks: { meatballColor },
	} = useTheme()

	const handleMeatballMenu = () => {
		setShowMenu(!showMenu)
	}

	const handleEscMenu = (event) => {
		if (event.key === 27 || event.key === 'Escape') {
			return setShowMenu(false)
		}
	}

	useEffect(() => {
		const handleOffClick = (event) => {
			if (showMenu) {
				overlayRef.current.contains(event.target) && setShowMenu(false)
			}
		}

		if (showMenu) {
			document.addEventListener('mousedown', handleOffClick)
			document.addEventListener('keydown', handleEscMenu)
		}

		return () => {
			document.removeEventListener('mousedown', handleOffClick)
			document.removeEventListener('keydown', handleEscMenu)
		}
	})

	return (
		<>
			<MenuWrapper isMenuVisible={showMenu}>
				<Plate onClick={handleMeatballMenu}>
					<MeatballWrapper>
						<Meatball />
						<Meatball />
						<Meatball />
					</MeatballWrapper>
				</Plate>
				{showMenu && (
					<>
						<Menu>
							<CloseButton onClick={handleMeatballMenu}>
								<Plus color={meatballColor} />
							</CloseButton>
							{elements.map((element, i) => {
								const { id, title } = element
								return (
									<ElementLink key={i} onClick={handleMeatballMenu} href={`#${id}`}>
										{title}
									</ElementLink>
								)
							})}
						</Menu>
					</>
				)}
			</MenuWrapper>
			<Overlay isOverlayVisible={showMenu} ref={overlayRef} />
		</>
	)
}
